export default {
    path: '/imgList',
    meta: {
        title: "详情"
    },
    component: () => import('@/views/imgList/imgList')
}